const currentProductSelectors = function() {
  const self = {};

  // NOTE: this is a private method to protect agains use out side of this
  // files scope
  // select the current product that is in focus
  // typically used to display the product details page
  const _select = function(state) {
    return state.currentProduct;
  };

  // exposes the private method but gives flexability to
  // be able to construct the shape of the currentProduct
  // object if the root ever changes shape and other pages need
  // the older shape
  self.selectCurrentProduct = function(state) {
    return _select(state);
  };

  // select the details of the product
  self.selectDetails = function(state) {
    const root = _select(state);

    return root.details;
  };

  // select the versions of the product
  self.selectVersions = function(state) {
    const root = _select(state);

    return root.versions;
  };

  self.selectVersionsList = function(state) {
    const versions = self.selectVersions(state);

    return versions.list;
  };


  // select the generic event of the product, includes some state
  // of ack or read
  self.selectEvent = function(state) {
    const root = _select(state);

    return root.event;
  };

  // select the products procedure string
  self.selectProcedure = function(state) {
    const event = self.selectEvent(state);

    // while loading event list this could be undefined
    if (!event) return '';

    return event.content.procedure;
  };

  // select if the currentProduct state is in a loading read state
  self.selectLoadingReadState = function(state) {
    const currentProduct = self.selectCurrentProduct(state);

    return currentProduct.loadingReadState;
  };

  // select if the current product is loading event/details ect
  self.selectLoading = function(state) {
    const root = _select(state);

    return root.loading;
  };

  // select if the product has an error doing an action to it. like
  // loading reading
  self.selectError = function(state) {
    const root = _select(state);

    return root.error;
  };

  self.selectErrorMessage = function(state) {
    const error = self.selectError(state);
    if (!error) return null;

    if (error.hasOwnProperty('response')) {
      const errorResponse = error.response;
      if (errorResponse.hasOwnProperty('status')) {
        const { status } = errorResponse;
        if (status === 404) {
          const { data } = errorResponse;
          const { details, message } = data;

          // NOTE: this is some magic that we use to see
          // if the product was not found vs other edge cases
          // our backend send a message: sql: no rows in result set
          if (details.indexOf('no rows') !== -1) {
            return 'No notification found';
          }

          return message;
        }
      }

      if (errorResponse.hasOwnProperty('data')) {
        const errorData = errorResponse.data;
        if (errorData.hasOwnProperty('message')) {
          return errorData.message;
        }
      }
    }

    return error;
  };

  self.selectAckInProgress = function(state) {
    const root = _select(state);

    return root.ackInProgress;
  };

  return self;
};

export default currentProductSelectors();
